import React from 'react';
import GlobalContext from '../../GlobalContext';
import QuoteRequestForm, { BrochureBtn, VideoButton } from '../../BFComponents';

const CanonMF264cdw = () => {
    const  paths =GlobalContext().paths;
    return (

        <div className="container">
            <div className="row">
                <div className="col-md-4">
                    <img className="my-2" src={paths.pictures + "mf264.svg"}></img>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <img className="img-100" src={paths.pictures + "264cdw.jpg"}></img>
                </div>
                <div className="col-md-6">
                    <h4>PRODUCTIVE PRINTING</h4>
                    <h3><strong>THAT MAKES BUSINESS SENSE.</strong></h3>
                    A Multi-Function Printer that means serious business – the imageCLASS MF260 series. Well-equipped
to deliver more, this line-up is designed to optimise your workflow in the office. Print, scan, copy, fax
reliably with ease and get the job done in no time, always. The imageCLASS MF260 series is a business
partner you can always count on.
                    <QuoteRequestForm source={window.location} />
                    <BrochureBtn brochure={"Canon imageCLASS MF264dw Brochure.pdf"} />
                    <div className="row">
                        <div className="col-md-6">
                            <VideoButton id={"VxUrTzGRYnFg"} />
                        </div> <div className="col-md-6">
                            <VideoButton id={"Vz35ELHuxfkw"} />
                        </div>
                    </div>
                </div>
            </div>

            <h2 className="h264">HIGH PERFORMANCE</h2>

            <div className="d-flex">
                <img className="p-2 width100px" src={paths.pictures + "ddefficiency-02.svg"}></img>
                <div className="d-flex flex-column m-1">
                    <div className="h265"><strong>DOUBLE-DOWN EFFICIENCY</strong></div>
                    <div>
                        Automate scanning up to 35 sheets of documents with the Auto Document Feeder (ADF) in MF266dn and MF264dw. The Duplex
ADF in MF269dw is capable of scanning up to 50 sheets two-sided originals, for an added efficiency.                </div>
                </div>

            </div>

            <div className="row">
                <div className="col-md-6">
                    <div className="d-flex">
                        <div className="align-self-start">
                            <img className="p-2 width100px" src={paths.pictures + "ddefficiency-04.svg"}></img>
                        </div>
                        <div className="d-flex flex-column m-1">
                            <div className="h265">
                                <strong> SIZED TO YOUR NEEDS</strong>
                            </div>
                            <div>
                                The MF260 series gives you the flexibility of printing on A5 and A6 paper sizes. The ideal companion to print invoices, flyer, business leaflets and reports.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="d-flex">
                        <div className="align-self-start">
                            <img className="p-2 width100px" src={paths.pictures + "ddefficiency-06.svg"}></img>
                        </div>
                        <div className="d-flex flex-column m-1">
                            <div className="h265"><strong>SUPERB PRINT SPEED</strong></div>
                            <div> Better efficiency with Canon’s On Demand Fixing Technology, the MF260 series produces quality printouts at a rapid speed of 28ppm.</div>
                        </div>
                    </div>
                </div>
            </div>

            <h2 className="h264">TOTAL CONVENIENCE</h2>
            <div className="d-flex">
                <div className="align-self-start">
                    <img className="p-2 width100px" src={paths.pictures + "ddefficiency-01.svg"}></img>
                </div>
                <div className="d-flex flex-column m-1">
                    <div className="h265"><strong>ONE-TOUCH SOLUTIONS</strong></div>
                    <div>
                        Available on MF269dw and MF266dn, the 6-line LCD touch panel gives you everything you need at a glance. For frequently accessed functions such as Paper Save Copy, ID Card Copy and Scan to PC, one-touch solution keys have been pre-configured to enable you perform these tasks with ease.
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="d-flex">
                        <div className="align-self-start">
                            <img className="p-2 width100px" src={paths.pictures + "ddefficiency-03.svg"}></img>
                        </div>
                        <div className="d-flex flex-column m-1">
                            <div className="h265">
                                <strong>SCAN & SHARE</strong>
                            </div>
                            <div>
                                Make full use of Canon’s SEND technology for easier sharing and exchange of documents. Scan and send via email or shared folder directly from your multi-function printer.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="d-flex">
                        <div className="align-self-start">
                            <img className="p-2 width100px" src={paths.pictures + "ddefficiency-05.svg"}></img>
                        </div>
                        <div className="d-flex flex-column m-1">
                            <div className="h265">
                                <strong>INTEGRATE SEAMLESSLY</strong>
                            </div>
                            <div>
                                The built-in PCL language ensures compatibility with a wide range of business applications. Canon’s proprietary UFR II LT print language helps to speed up document processing and printing for added productivity round the clock.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    )
}

export default CanonMF264cdw;